import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "/advertiser/products";
const options = {role: ROLE.ADVERTISER};


export const GetSellerProducts = async (values) => {
  return await axiosInstance(options).post(`${path}/get-all-seller-products`, values);
};
export const CreateProducts = async (values) => {
  return await axiosInstance(options).post(`${path}/create-product`, values);
};
export const UpdateProduct = async (values) => {
  return await axiosInstance(options).put(`${path}/update-product`, values);
};

export const DeleteProduct = async (id) => {
  return await axiosInstance(options).delete(`${path}/delete-product?_id=${id}`);
};
export const getProductDetails = async (value) => {
  return await axiosInstance(options).get(`${path}/product-details?o_id=${value}`);
}

export const productListOptions = async () => {
  return await axiosInstance(options).get(`${path}/product-list-invoice`);
}




